import React, { useState, useEffect } from 'react';
import './Admin.css';
import useTrainingStore from '../stores/TrainingStore';


const Admin = () => {
    const [message, setMessage] = useState(""); // Nachricht für Erfolg oder Fehler
    const [placeholderText, setPlaceholderText] = useState("");

    const { anwesendAdmin, abwesendAdmin, isTrainingCanceled } = useTrainingStore(); // Anwesenheitsliste aus dem Kontext abrufen
    const { getTrainingsVotesValuesWithNames, saveTrainingText, getAdminisAbsent } = useTrainingStore();
    const { updateTrainingText, getTraining } = useTrainingStore();

    useEffect(() => {
        // Admin-Text und Anwesenheitsliste abrufen
        getAdminisAbsent();
        getTraining();
        getTrainingsVotesValuesWithNames();
    }, []);

    const handleTrainingTextChange = (e) => {
        setPlaceholderText(e.target.value);
    };

    const handleSaveTrainingText = async () => {
        try {
            await saveTrainingText({ text: placeholderText });
            setMessage("Admin-Text erfolgreich gespeichert!");
        } catch (error) {
            console.error("Fehler beim Speichern des Admin-Texts:", error);
            setMessage("Fehler beim Speichern des Admin-Texts.");
        }
    };

    return (
        <div className="admin-container">
            <h2>Admin Bereich</h2>

            <div>
                {isTrainingCanceled && (
                    <div className="training-canceled-container">
                        <h2 className="important-header">WICHTIG!!!</h2>
                        <p className="training-canceled-text">Du hast das Training abgesagt, denk dran wieder teilzunehemen, sobald du wieder Lust hast zu trainieren</p>
                    </div>
                )}
            </div>

            {/* Admin Text bearbeiten */}
            <div className="admin-text-container">
                <textarea
                    value={placeholderText}
                    onChange={handleTrainingTextChange}
                    rows="5"
                    cols="50"
                    placeholder="Geben Sie hier den Text ein, den die Teilnehmer sehen sollen..."
                />
                <button className="save-button" onClick={handleSaveTrainingText}>Text speichern</button>
                {message && <p className="message">{message}</p>}
            </div>

            <h3>Anwesenheitsliste</h3>

            {/* Anwesenheitsliste */}
            <div className="attendance-container">
                <div className="attendance-group">
                    <h4>Anwesend:</h4>
                    <table className="attendance-table">
                        <thead>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    {/* Display names of users absent */}
                                    {anwesendAdmin.length > 0
                                        ? anwesendAdmin.map((name, index) => (
                                            <div key={index}>{name}</div>
                                        ))
                                        : 'Niemand nimmt teil'}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="attendance-group">
                    <h4>Abwesend:</h4>
                    <table className="attendance-table">
                        <thead>
                        </thead>
                        <tbody>
                            <tr>
                            <td>
                                    {/* Display names of users absent */}
                                    {abwesendAdmin.length > 0
                                        ? abwesendAdmin.map((name, index) => (
                                            <div key={index}>{name}</div>
                                        ))
                                        : 'Niemand nimmt nicht teil'}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Admin;
